module.exports = __webpack_public_path__ + "static/fonts/Mont-Heavy.225714c.eot";